export { default, handle } from "/tmp/build/apps/asap/src/routes/auth.tsx";